<template>
  <BaseAction>
    <PrimaryButton @click.native="openDialog" :full-width="isMobile">
      Request Interview
    </PrimaryButton>
    <RequestInterviewDialog
      :isOpen="isOpen"
      @close="closeDialog"
      :applicationsIds="applicationsIds"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RequestInterviewDialog from "@/views/bookings/components/ConfirmDialogs/RequestInterviewDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "RequestInterviewAction",
  components: {
    BaseAction,
    PrimaryButton,
    RequestInterviewDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    applicationsIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
